import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = sanityClient({
  projectId: 'dmr32ue9',
  dataset: 'production',
  apiVersion: '2022-02-01',
  useCdn: true,
  token:'skbHlOc1oMdtHGUO1wdMLfwZL7SPXX4zbMOhmK0X3AcOv3fkiT4zk0aHe7vJpMbdOVBi8BqXRQLJXVrnZ2uJKT2SV0ug3AsV5MGreyHPQ9pdvXFbwnyz67c2tglmaL2yqGM5Wyu7WtG3hiZILyWPGb1igIw346M2R8xMBsZWTQJF14kKqPCe',
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);